"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _BaseForm = _interopRequireDefault(require("react-platform-components/dist/BaseComponents/BaseForm"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Translations = require("react-platform-components/dist/Translations");
var _uploader = require("react-platform-components/dist/uploader");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var isErrored = function isErrored(props, key) {
  return props.touched && props.touched[key] && props.errors && props.errors[key];
};

// EditProfile form fields
var getFormExtraFields = function getFormExtraFields(props) {
  return [/*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    fullWidth: true,
    variant: "outlined",
    type: "text",
    name: "last_name",
    label: "Nom",
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    fullWidth: true,
    variant: "outlined",
    type: "text",
    name: "first_name",
    label: "Pr\xE9nom",
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    fullWidth: true,
    variant: "outlined",
    type: "text",
    name: "email",
    label: "Email",
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.PhoneNumber, {
    placeholder: "T\xE9l\xE9phone *",
    name: "phone",
    country: "fr",
    disableAreaCodes: true,
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    style: {
      color: isErrored(props, 'avatar') ? '#f44336' : '#908f8f'
    }
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Photo de profil",
    defaultMessage: "Photo de profil"
  })), isErrored(props, 'avatar') && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    style: {
      color: '#f44336'
    }
  }, props.errors.avatar)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    xs: 12,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_formFields.ImageUploaderEditable, {
    name: "avatar",
    maxTotalSize: 1000000,
    acceptedFiles: "image/bmp,image/gif,image/jpeg,image/png,image/x-ms-bmp"
    // validate={required()}
  })))];
};

// EditProfile form
var _default = (0, _BaseInjectors.injectToForm)(_BaseForm.default, {
  formExtraFields: function formExtraFields(props) {
    return getFormExtraFields(props);
  },
  handleInitialValues: function handleInitialValues(props) {
    var user = props.user;
    return {
      last_name: user.last_name,
      first_name: user.first_name,
      email: user.email,
      phone: user.phone,
      avatar: user.avatar ? user.avatar.original : ''
    };
  }
});
exports.default = _default;